import defaultAvatarImage from "@/public/static/images/member-default-avatar.jpg";
import defaultAvatarImage2 from "@/public/static/images/member-default-avatar-2.jpg";
import defaultAvatarImage3 from "@/public/static/images/member-default-avatar-3.jpg";
import defaultAvatarImage4 from "@/public/static/images/member-default-avatar-4.jpg";

import Image from "./Image";

const defaultAvatars = [
  defaultAvatarImage.src,
  defaultAvatarImage2.src,
  defaultAvatarImage3.src,
  defaultAvatarImage4.src,
];

const generateDefaultAvatar = (member) => {
  const hashVal = (member.id * 13) ** 3 % defaultAvatars.length;
  return defaultAvatars[hashVal];
};

const getUserAvatar = (member) =>
  member.profile?.avatar || member.avatar || generateDefaultAvatar(member);

const AvatarImage = ({ member }) => (
  <Image
    className="is-cover"
    defaultImage={generateDefaultAvatar(member)}
    src={getUserAvatar(member)}
    alt="avatar"
  />
);

const AvatarList = () => (
  <>
    {defaultAvatars.map((src) => (
      <Image key={src} className="is-cover" src={src} />
    ))}
  </>
);

export default AvatarImage;

export { AvatarList, defaultAvatars, generateDefaultAvatar };
